export interface Customer {
  id?: string;
  name?: string;
  email?: string;
  phone?: string;
  isBlocked?: boolean;
  orders?: object[];
  walletBalance?: number;
  createdAt?: any;
  updatedAt?: any;
  deletedAt?: any;
  isDeleted?: boolean;
}



export function assignValueToObject(query: any) {
  return {
    id: query.id,
    ...query?.data()
  };
}
